import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Login from './routes/Login';
import RequireAuth from './routes/RequireAuth';

// Code-split each main route. Home is loaded eagerly because it's the
// landing page after login.
const Home = lazy(() => import('./routes/Home'));
const ProjectsList = lazy(() => import('./routes/ProjectsList'));
const ProjectDetail = lazy(() => import('./routes/ProjectDetail'));
const NewProject = lazy(() => import('./routes/NewProject'));
const InitiativesList = lazy(() => import('./routes/InitiativesList'));
const InitiativeDetail = lazy(() => import('./routes/InitiativeDetail'));
const Portfolio = lazy(() => import('./routes/Portfolio'));
const Ideas = lazy(() => import('./routes/Ideas'));
const Tickets = lazy(() => import('./routes/Tickets'));
const Admin = lazy(() => import('./routes/Admin'));
const ReleasesList = lazy(() => import('./routes/ReleasesList'));
const ReleaseDetail = lazy(() => import('./routes/ReleaseDetail'));
const Messages = lazy(() => import('./routes/Messages'));
const Help = lazy(() => import('./routes/Help'));
const Components = lazy(() => import('./routes/Components'));

function RouteFallback() {
  return (
    <div style={{ color: 'var(--apm-muted)', padding: 24 }}>Loading…</div>
  );
}

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: '/portfolio',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Portfolio />
          </Suspense>
        ),
      },
      {
        path: '/initiatives',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <InitiativesList />
          </Suspense>
        ),
      },
      {
        path: '/initiatives/:id',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <InitiativeDetail />
          </Suspense>
        ),
      },
      {
        path: '/projects',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <ProjectsList />
          </Suspense>
        ),
      },
      {
        path: '/projects/new',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <NewProject />
          </Suspense>
        ),
      },
      {
        path: '/projects/:id',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <ProjectDetail />
          </Suspense>
        ),
      },
      {
        path: '/ideas',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Ideas />
          </Suspense>
        ),
      },
      {
        path: '/components',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Components />
          </Suspense>
        ),
      },
      {
        path: '/tickets',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Tickets />
          </Suspense>
        ),
      },
      {
        path: '/releases',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <ReleasesList />
          </Suspense>
        ),
      },
      {
        path: '/releases/:id',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <ReleaseDetail />
          </Suspense>
        ),
      },
      {
        path: '/messages',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Messages />
          </Suspense>
        ),
      },
      {
        path: '/help',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Help />
          </Suspense>
        ),
      },
      {
        path: '/admin',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Admin />
          </Suspense>
        ),
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
